import { cn } from "@/utils/css";

export const ChatMessageBubble = ({ role, text }) => {
    const isUser = role === "user";
    return (
        <div className={cn("flex w-full", isUser ? "justify-end" : "justify-start")}>
            <div
                className={cn(
                    "max-w-[85%] rounded-[19px] text-[16px] leading-[21px] whitespace-pre-wrap break-words",
                    isUser
                        ? "bg-cm-p-accent-400 text-cm-p-neutral-dark-500 p-[14px] rounded-br-none"
                        : "bg-cm-p-surface text-cm-p-text-primary px-[14px] py-3 rounded-bl-none shadow-[0px_0px_2px_rgba(0,0,0,0.04)]",
                )}
            >
                {text}
            </div>
        </div>
    );
};
